import { apiRequest } from '../../lib/api';
import { coverageStateSchema, roomBotResultSchema } from '../../lib/schemas';
import type { CoverageState } from '../../types';

export function getTeamCoverage(signal?: AbortSignal): Promise<CoverageState> {
  return apiRequest('/api/rooms/coverage', coverageStateSchema, signal ? { signal } : {});
}

export function joinRoom(eventId: number, botName: string) {
  return apiRequest(`/api/rooms/${eventId}/join`, roomBotResultSchema, {
    method: 'POST',
    body: JSON.stringify({ botName }),
  });
}

export function leaveRoom(eventId: number) {
  return apiRequest(`/api/rooms/${eventId}/leave`, roomBotResultSchema, { method: 'POST' });
}
